import { getValueFromOptions } from 'Util/formatters'
import { t } from 'ttag'
import { ServiceProviderType } from '../../serviceProviderSlice'

interface ServiceProviderTypeProps {
  serviceProviderType?: ServiceProviderType
}

function ServiceProviderTypeValue({ serviceProviderType }: ServiceProviderTypeProps) {
  const serviceProviderTypeOptions = [
    {
      label: t`Traffic contractor`,
      value: ServiceProviderType.TRAFFIC_CONTRACTOR
    },
    {
      label: t`U Traffic contractor`,
      value: ServiceProviderType.U_TRAFFIC_CONTRACTOR
    },
    {
      label: t`Sales point`,
      value: ServiceProviderType.SALES_POINT
    },
    {
      label: t`Service point`,
      value: ServiceProviderType.SERVICE_POINT
    },
    {
      label: t`HSL digital channel`,
      value: ServiceProviderType.HSL_DIGITAL_CHANNEL
    },
    {
      label: t`MaaS`,
      value: ServiceProviderType.MAAS
    },
    {
      label: t`Other`,
      value: ServiceProviderType.OTHER
    },
    {
      label: t`Ticket machine`,
      value: ServiceProviderType.TICKET_MACHINE
    },
    {
      label: t`Webshop`,
      value: ServiceProviderType.WEBSHOP
    },
    {
      label: t`Mobile`,
      value: ServiceProviderType.MOBILE
    },
    {
      label: t`Event ticket`,
      value: ServiceProviderType.EVENT_TICKET
    }
  ]

  return (
    <>
      {serviceProviderType &&
        getValueFromOptions(serviceProviderType, serviceProviderTypeOptions, '-')}
    </>
  )
}

export default ServiceProviderTypeValue
